import React, { useState } from 'react'
import Collapsible from 'react-collapsible'
import styles from '../Components/LanguagesSpoken.module.css'
import { FaLanguage } from "react-icons/fa";
import LanguagesSpokenEachWrapper from './LanguagesSpokenEachWrapper';

const LanguagesSpoken = props => {
    const [isOpen, setIsOpen] = useState(false);
    const { data } = props

    return (
        <div className={styles.mainWrapper}>
            <Collapsible trigger={
                <div className={isOpen === true ? styles.mainHeaderOpen : styles.mainHeader}>
                    <div className={styles.leftCol}>
                        <FaLanguage />
                        <span className={styles.headerTitle}>
                            Language Spoken
                        </span>
                    </div>
                    <div className={styles.rightCol}>

                    </div>
                </div>
            }
                isOpen={false}
                onOpening={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
            >

                <div className={styles.mainContainer}>
                    {data?.map((item, index) => (
                        <LanguagesSpokenEachWrapper
                            item={item}
                            key={index}
                        />
                    ))}
                </div>
            </Collapsible>
        </div>
    )
}

export default LanguagesSpoken